<template>
  <page :breadcrumbBar="false" :title="title" :load="doInit">
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 md3>
          <v-navigation-drawer permanent light width="100%" class="mavSmallMenu">
              <v-toolbar flat>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title class="title">
                        {{ productCode }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-toolbar>
              <v-list class="pt-0">
                <v-divider></v-divider>
                <v-list-tile v-for="item in sideMenu" :key="item.name" :to="{ name: item.name }">
                  <v-list-tile-action v-if="item.name === 'packageStdCommDiscFactors'">
                    <v-icon :class="isMatchRoute('packageStdCommDiscFactorsReview') ? 'primary--text':''">{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-action v-else>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content v-if="item.name === 'packageStdCommDiscFactors'">
                    <v-list-tile-title :class="isMatchRoute('packageStdCommDiscFactorsReview') ? 'primary--text':''">{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content v-else>
                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 md9>
          <transition name="slide-x-transition" mode="out-in">
            <router-view ></router-view>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { appID } from '@/const/underwriting'
import { PARAMETERS_APPID } from '@/store/types'
import routeMixin from '@/mixins/route'

export default {
  data() {
    return {
      breadcrumb: [],
      sideMenu: [
        { name: 'packageProductReview', text: 'Product', icon: 'mdi-cube-outline' },
        { name: 'packageProductBusClsReview', text: 'Business Class', icon: 'mdi-calculator' },
        { name: 'packageProductCampaignReview', text: 'Campaign', icon: 'mdi-calendar-clock' },
        { name: 'packageProductSchemeReview', text: 'Scheme', icon: 'mdi-file-document-box' },
        { name: 'packageStdCommDiscFactors', text: 'Commission/Discount', icon: 'mdi-sale' }
      ],
      newProduct: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    title() {
      return ' '
    },
    productCode() {
      if (this.product) {
        return this.product
      } else {
        return 'New Product'
      }
    }
  },
  methods: {
    async doInit() {
      this.$store.commit(PARAMETERS_APPID, appID.PACKAGE)
      if (this.product === 'new') {
        this.newProduct = true
        this.sideMenu = [
          { name: 'packageProductReview', text: 'Product', icon: 'mdi-cube-outline' }
        ]
      } else {
        await this.$store.dispatch('productMenuInit', this.product)
        this.sideMenu = [
          { name: 'packageProductReview', text: 'Product', icon: 'mdi-cube-outline' },
          { name: 'packageProductBusClsReview', text: 'Business Class', icon: 'mdi-calculator' },
          { name: 'packageProductCampaignReview', text: 'Campaign', icon: 'mdi-calendar-clock' },
          { name: 'packageProductSchemeReview', text: 'Scheme', icon: 'mdi-file-document-box' },
          { name: 'packageStdCommDiscFactors', text: 'Commission/Discount', icon: 'mdi-sale' }
        ]
      }
    }
  },
  props: {
    product: {
      type: String,
      default: ''
    }
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style lang="scss">
</style>
